import { render, staticRenderFns } from "./quotation-summary.vue?vue&type=template&id=120f9459&scoped=true"
import script from "./quotation-summary.vue?vue&type=script&lang=js"
export * from "./quotation-summary.vue?vue&type=script&lang=js"
import style0 from "./quotation-summary.vue?vue&type=style&index=0&id=120f9459&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120f9459",
  null
  
)

export default component.exports